<template>
  <div>
    <KeywordPlannerAddNegativeKeywordForm
      :show="show && !errors.length"
      @error="handleError"
      @back="back"
      @hide="close"
    />

    <KeywordPlannerAddNegativeKeywordError
      :show="show && Boolean(errors.length)"
      :errors="errors"
      @hide="resetErrorsAndClose"
    />
  </div>
</template>

<script>
import KeywordPlannerAddNegativeKeywordForm from './KeywordPlannerAddNegativeKeywordForm';
import KeywordPlannerAddNegativeKeywordError from './KeywordPlannerAddNegativeKeywordError';

export default {
  name: 'KeywordPlannerAddNegativeKeyword',
  components: {
    KeywordPlannerAddNegativeKeywordForm,
    KeywordPlannerAddNegativeKeywordError,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      errors: [],
    };
  },
  methods: {
    handleError(errors) {
      this.errors = errors;
    },
    back() {
      this.$emit('back');
    },
    resetErrorsAndClose() {
      this.errors = [];

      this.close();
    },
    close() {
      this.$emit('hide');
    },
  },
};
</script>
